const options = {
  5: "bg-fuchsia-100/5",
  10: "bg-fuchsia-100/10",
  25: "bg-fuchsia-100/25",
  50: "bg-fuchsia-100/50",
  75: "bg-fuchsia-100/75",
  90: "bg-fuchsia-100/90",
  100: "bg-fuchsia-100",
};

const from = {
  5: "from-fuchsia-100/5",
  10: "from-fuchsia-100/10",
  25: "from-fuchsia-100/25",
  50: "from-fuchsia-100/50",
  75: "from-fuchsia-100/75",
  90: "from-fuchsia-100/90",
  100: "from-fuchsia-100",
};

export default function getBackgroundFuchsia100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
